export function safeRequestIdleCallback(cb, timeoutMS) {
    if ('requestIdleCallback' in self) {
        if (!timeoutMS) {
            requestIdleCallback(cb);
        } else {
            requestIdleCallback(cb, {
                timeout: timeoutMS
            });
        }
        return;
    }
    setTimeout(cb, timeoutMS || 1);
}

//# sourceMappingURL=safe-request-idle-callback.js.map